import { RouteProp, useRoute } from "@react-navigation/native";
import { useGetCourseByIdQuery } from "../../../graphql/generated/graphql";
import { Text, View } from "react-native";
import CustomCourseWorkContentMenu from "../../../components/navigation/CustomCourseWorkContentMenu/CustomCourseWorkContentMenu";
import { RootStackParamList } from "../../../navigation/AppNavigator.web";

function CustomCourseworkMenuContainer({
  onSelectModule,
  onSelectActivity,
  selectedModule,
  selectedActivity,
  onAddModule,
}) {
  const route = useRoute<RouteProp<RootStackParamList, "Custom Coursework Modules">>();
  const courseId = route.params?.courseId;

  const { data: courseData, loading } = useGetCourseByIdQuery({
    variables: {
      id: courseId,
    },
  });

  const selectedCourse = courseData?.getCourseById?.data[0];

  if (loading)
    return (
      <View>
        <Text>Loading...</Text>
      </View>
    );

  return (
    <>
      {selectedCourse ? (
        <CustomCourseWorkContentMenu
          data={selectedCourse}
          onSelectModule={onSelectModule}
          onSelectActivity={onSelectActivity}
          selectedModule={selectedModule}
          selectedActivity={selectedActivity}
          onAddModule={onAddModule}
        />
      ) : (
        <View>
          <Text>No courses available</Text>
        </View>
      )}
    </>
  );
}

export default CustomCourseworkMenuContainer;
